import React from 'react';
import { motion } from 'framer-motion';
import Images from '../../../assets/images/index';
import styles from './Hero.module.scss';

const Hero = () => {
    return (
        <section
            className={styles.bannerSection}
            style={{ backgroundImage: `url(${Images.contactUs})` }}
        >
            <motion.div
                className={styles.content}
                initial={{ opacity: 0, y: 40, scale: 0.95 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                transition={{ duration: 0.8, ease: 'easeOut' }}
                viewport={{ once: true, amount: 0.4 }}
            >
                <motion.h1
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, delay: 0.2 }}
                    viewport={{ once: true }}
                >
                    Get In Touch with <span>DGMtech Solutions</span>
                </motion.h1>

                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                    viewport={{ once: true }}
                >
                    We’re Here to Help!
                </motion.p>
            </motion.div>
        </section>
    );
};

export default Hero;
